import React from 'react'
import { Route } from "react-router-dom";
import { DashboardFiscalMain } from './Dashboard/DashboardFiscalMain';
import { ListadoInvoiceMovimientosScreen } from './CorreccionIncidenciasReporte/ListadoInvoiceMovimientosScreen';
import { ConciliacionIngresosScreen } from './ConciliacionIngresosReporte/ConciliacionIngresosScreen';
import { ListadoScreenFiscal } from './ListadoScreenFiscal';
import { PruebaScreen } from './Prueba/PruebaScreen';

export const FiscalMainScren = () => {
  return (
    <div className="main-container">
      <Route
        path="/Fiscal/Main"
        component={() => <ListadoScreenFiscal />}
      />
      <Route
        path="/Fiscal/ListadoInvoice"
        component={() => <ListadoInvoiceMovimientosScreen />}
      />
      <Route
        path="/Fiscal/ConciliacionIngresos"
        component={() => <ConciliacionIngresosScreen />}
      />
      <Route
        path="/Fiscal/ConciliacionIngresosAnalitica"
        component={() => <ConciliacionIngresosScreen />}
      />
      <Route
        path="/Fiscal/ConciliacionIngresosInvoice"
        component={() => <ConciliacionIngresosScreen />}
      />
    </div>
  )
}
